import { PresentedState } from '../../common/reducers/types';
import { Page } from '../../common/types';

const PageMap: Record<Page, string> = {
  [Page.Home]: 'home',
  [Page.Category]: 'category',
  [Page.Categories]: 'categories',
  [Page.Article]: 'article',
  [Page.Search]: 'search_results',
  [Page.Chatbot]: 'chatbot',
};

export const pageEnumToString = (page: Page): string => {
  return PageMap[page];
};

export const presentedStateToPage = (presentedState: PresentedState | undefined): Page => {
  switch (presentedState) {
    case PresentedState.Homepage:
      return Page.Home;
    case PresentedState.SearchResults:
      return Page.Search;
    case PresentedState.AllHelpTopics:
    case PresentedState.SubCategoriesList:
    case PresentedState.SolutionList:
      return Page.Categories;
    case PresentedState.SingleArticle:
      return Page.Article;
    case PresentedState.Chatbot:
      return Page.Chatbot;
    default:
      return Page.Home; // Default fallback
  }
};
